import { useEffect, useState } from "react";
import { api, API } from "../lib/api";

/**
 * Auth-aware image. Backend files endpoint requires a JWT, so we fetch the
 * blob ourselves and stream it into an <img>. Falls back gracefully if there
 * is no source.
 */
export default function AuthImage({ src, alt = "", className = "", fallback = null, onClick, "data-testid": testId }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let active;
    setBlobUrl(null);
    if (!src) return;

    // External URLs (http/https) — render directly (e.g. YouTube thumbnails)
    if (/^https?:\/\//i.test(src)) {
      setBlobUrl(src);
      return () => {};
    }

    const path = src.startsWith("/api/") ? src.replace(/^\/api/, "") : src;
    api
      .get(path, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        active = URL.createObjectURL(res.data);
        setBlobUrl(active);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (active) URL.revokeObjectURL(active);
    };
  }, [src]);

  if (!src || !blobUrl) {
    return fallback || <div className={className} data-testid={testId} aria-hidden="true" onClick={onClick} />;
  }
  return <img src={blobUrl} alt={alt} className={className} onClick={onClick} data-testid={testId} loading="lazy" decoding="async" />;
}

export function externalFileUrl(src) {
  if (!src) return null;
  if (/^https?:\/\//i.test(src)) return src;
  return `${API}${src.startsWith("/api/") ? src.replace(/^\/api/, "") : src}`;
}
